import { Link, useNavigate } from "react-router-dom";
import deleteItems from "../utils/delete function";
import addOrRemoveFavorites from "../utils/favorite function";
import getCartImage from "../utils/cart images function";
import { Button, Checkbox, Flex, Loader, Popover, Rating } from "@mantine/core";
import DeleteIcon from "@mui/icons-material/Delete";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import pushProductToCloud from "../utils/push product function";
import FavoriteOutlinedIcon from "@mui/icons-material/FavoriteOutlined";
import EditIcon from "@mui/icons-material/Edit";

const useGetMappedData = (
  realTimeData,
  comProductsArr,
  productsArr,
  userId,
  interestsObj,
  quantity,
  openOptions,
  setProductsToDelete,
  productsToDelete,
  chatRoomObject,
  setOpenOptions
) => {
  const navigate = useNavigate();

  const mappedCart = realTimeData.cart?.map((prod, i) => {
    return (
      <div key={i} className="cart-prod-wrapper">
        <Flex p={5} align="center" justify="space-between" gap=".5rem">
          <div className="cart-img-wrapper">
            <img
              className="cart-img-only"
              src={getCartImage(prod.pId, productsArr)}
              alt=""
            />
          </div>
          <div>
            <p style={{ fontWeight: 620 }}>{prod.pName}</p>
            <p>€{prod.pPrice}</p>
            <p>Qty: {prod.pQuantity}</p>
          </div>
          <div className="dots">
            <Popover width={150} position="top">
              <Popover.Target>
                <MoreVertIcon
                  sx={{
                    cursor: "pointer",
                  }}
                />
              </Popover.Target>
              <Popover.Dropdown>
                <button className="more-menu-options">
                  <Link to={`/products/${prod.pId}`}>Check store page</Link>
                </button>
                <button
                  id={i}
                  onClick={() => deleteItems(prod.pId, userId, realTimeData)}
                  className="more-menu-options"
                >
                  Remove
                </button>
              </Popover.Dropdown>
            </Popover>
          </div>
        </Flex>
      </div>
    );
  });

  const mappedSoldByMe = comProductsArr
    ?.filter((prod) => prod.sellerId === userId)
    .map((item, index) => {
      return (
        <div
          onClick={() => {
            if (
              openOptions.productDeletSelector === false &&
              openOptions.productEditMode === false
            )
              navigate(`/community-sellings/${item.id}`);
          }}
          style={{
            border: "1px solid rgb(229, 229, 229)",
            cursor: "pointer",
          }}
          key={index}
          className="product-wrapper"
        >
          {openOptions.productDeletSelector ? (
            <div
              style={{
                position: "absolute",
                zIndex: "10",
              }}
            >
              <Checkbox
                size="md"
                color="yellow"
                onChange={(e) => {
                  e.stopPropagation();
                  if (!productsToDelete.includes(item.id)) {
                    setProductsToDelete((prev) => [...prev, item.id]);
                  } else {
                    const newArr = productsToDelete.filter(
                      (prod) => prod !== item.id
                    );
                    setProductsToDelete(newArr);
                  }
                }}
              />
            </div>
          ) : null}
          <div className="product-img-wrapper">
            <img
              className="product-img"
              src={item.images[0]}
              alt={item.title}
            />
          </div>
          <div className="second-part">
            <Flex align="center" justify="space-between">
              <h4>{item.title}</h4>
              <button
                style={{
                  border: "none",
                  background: "none",
                }}
                type="button"
              >
                <FavoriteOutlinedIcon
                  style={{
                    color: realTimeData.favorites?.includes(item.id)
                      ? "rgb(255, 201, 26)"
                      : "rgb(208, 208, 208)",
                    cursor: "pointer",
                  }}
                  onClick={(e) =>
                    addOrRemoveFavorites(
                      e,
                      item.id,
                      userId,
                      realTimeData.favorites
                    )
                  }
                />
              </button>
            </Flex>
            {/* <Flex align="center" gap="1rem">
              <Rating readOnly defaultValue={item.rating} fractions={2} />
              <p>{item.rating}/5</p>
            </Flex> */}
            <p>
              <i>Product sold by {item.sellerName}</i>
            </p>
          </div>
          <div className="third-part">
            <Flex align="center" justify="space-between">
              {openOptions.productEditMode ? (
                <button
                  onClick={() => {
                    // e.stopPropagation();
                    navigate(`/my-account/edit-products/${item.id}`);
                  }}
                  type="button"
                  style={{
                    background: "none",
                    display: "grid",
                    placeContent: "center",
                    border: "1px solid #d4d4d4",
                    borderRadius: "50%",
                    // color: "#d4d4d4",
                    padding: ".5rem",
                  }}
                >
                  <EditIcon
                    className="thin-grey-text more-options-hover"
                    style={{
                      fontSize: 18,
                    }}
                  />
                </button>
              ) : (
                <Button
                  disabled
                  // style={{
                  //   background: "none",
                  //   color: "rgb(255, 201, 26)",
                  // }}
                  className="blue-gradient-button"
                >
                  Contact
                </Button>
              )}
              <Flex>
                <p>
                  <b>€</b>
                </p>
                <h1>{item.price}</h1>
              </Flex>
            </Flex>
          </div>
        </div>
      );
    });

  const returnFavorites = () => {
    const idSet = new Set(realTimeData?.favorites);
    const newArr = productsArr.products?.filter((item) =>
      idSet.has(item.id.toString())
    );
    // console.log(newArr)
    return newArr;
  };

  const returnComFavorites = () => {
    const idSet = new Set(realTimeData?.favorites);
    const newArr = comProductsArr?.filter((item) =>
      idSet.has(item.id.toString())
    );
    const comProductsIdSet = new Set(comProductsArr?.map((item) => item.id));
    const missingProduct = realTimeData.favorites
      ?.filter((item) => !comProductsIdSet.has(item) && item.length > 10) //temp solution to exclude store products
      .map((item) => {
        return {
          id: item,
          images: ["../images/not_found_img.png"],
        };
      });
    // console.log(missingProduct);
    // console.log(newArr?.concat(missingProduct))
    return newArr?.concat(missingProduct);
  };

  const mappedFavorites = returnFavorites()?.map((prod, i) => {
    const discountedPrice = (
      prod.price -
      (prod.discountPercentage.toFixed(0) / 100) * prod.price
    ).toFixed(2);
    return (
      <div key={i} className="cart-prod-wrapper">
        <Flex p={5} justify="space-between" gap=".5rem">
          <div className="cart-img-wrapper">
            <img
              className="cart-img-only"
              src={getCartImage(prod.id.toString(), productsArr)}
              alt=""
            />
          </div>
          <div>
            <p style={{ fontWeight: 620 }}>{prod.title}</p>
            <p>€{discountedPrice}</p>
          </div>
          <div className="dots">
            <Popover width={160} position="top">
              <Popover.Target>
                <MoreVertIcon
                  sx={{
                    cursor: "pointer",
                  }}
                />
              </Popover.Target>
              <Popover.Dropdown>
                <button
                  pid={prod.id}
                  pname={prod.title}
                  pprod={discountedPrice}
                  ptaxes={((19 / 100) * discountedPrice).toFixed(2)}
                  className="more-menu-options"
                  onClick={(e) => pushProductToCloud(e, 1, userId)}
                >
                  Add to cart
                </button>
                <button className="more-menu-options">
                  <Link to={`/products/${prod.id}`}>Check store page</Link>
                </button>
                <button
                  onClick={(e) =>
                    addOrRemoveFavorites(
                      e,
                      prod.id,
                      userId,
                      realTimeData.favorites
                    )
                  }
                  className="more-menu-options"
                >
                  Remove
                </button>
              </Popover.Dropdown>
            </Popover>
          </div>
        </Flex>
      </div>
    );
  });

  const mappedComFavorites = returnComFavorites()?.map((prod, i) => {
    // console.log(returnComFavorites())
    return (
      <div key={i} className="cart-prod-wrapper">
        <Flex p={5} justify="space-between" gap=".5rem">
          <div className="fav-img-wrapper">
            <img className="cart-img-only" src={prod?.images[0]} alt="" />
          </div>
          {prod?.price ? (
            <div>
              <p style={{ fontWeight: 620 }}>{prod.title}</p>
              <p>€{prod?.price}</p>
            </div>
          ) : null}
          <div className="dots">
            <Popover width={150} position="top">
              <Popover.Target>
                <MoreVertIcon
                  sx={{
                    cursor: "pointer",
                  }}
                />
              </Popover.Target>
              <Popover.Dropdown>
                <button className="more-menu-options">
                  <Link to={`/community-sellings/${prod?.id}`}>
                    Check store page
                  </Link>
                </button>
                <button
                  onClick={(e) =>
                    addOrRemoveFavorites(
                      e,
                      prod.id,
                      userId,
                      realTimeData.favorites
                    )
                  }
                  className="more-menu-options"
                >
                  Remove
                </button>
              </Popover.Dropdown>
            </Popover>
          </div>
        </Flex>
      </div>
    );
  });

  // COMMUNITY PRODUCTS CARD
  const comProducts = comProductsArr.map((prod, i) => {
    const {
      brand,
      category,
      description,
      discountPercentage,
      id,
      images,
      price,
      rating,
      stock,
      thumbnail,
      title,
      sellerId,
      sellerName,
    } = prod;

    return (
      <div
        style={{ cursor: "pointer" }}
        onClick={() => navigate(`/community-sellings/${id}`)}
        key={i}
        className="product-wrapper"
      >
        <div className="product-img-wrapper">
          <img className="product-img" src={images[0]} alt={title} />
        </div>
        <div className="second-part">
          <Flex align="center" justify="space-between">
            <h4>{title}</h4>
            <button
              style={{
                border: "none",
                background: "none",
              }}
              type="button"
            >
              <FavoriteOutlinedIcon
                style={{
                  color: realTimeData.favorites?.includes(id.toString())
                    ? "rgb(255, 201, 26)"
                    : "rgb(208, 208, 208)",
                  cursor: "pointer",
                }}
                onClick={(e) =>
                  addOrRemoveFavorites(e, id, userId, realTimeData.favorites)
                }
              />
            </button>
          </Flex>
          <p>
            <i>Product sold by {sellerName}</i>
          </p>
        </div>
        <div className="third-part">
          <Flex align="center" justify="space-between">
            {chatRoomObject(id, sellerId) == null ? (
              <Button
                disabled={sellerId === userId}
                style={{
                  // background: "none",
                  // color: "rgb(255, 201, 26)",
                  padding: 5,
                }}
                className="blue-gradient-button"
                onClick={() => navigate(`/community-sellings/${id}`)}
              >
                Contact
              </Button>
            ) : chatRoomObject(id, sellerId)?.isChatRoomEnabled &&
              sellerId !== userId ? (
              <p>Chat accepted!</p>
            ) : !chatRoomObject(id, sellerId)?.isChatRoomEnabled &&
              sellerId !== userId ? (
              <div>
                <Flex align="center" gap="5px">
                  <Loader color="yellow" />
                  <p>Waiting for the seller..</p>
                </Flex>
              </div>
            ) : null}

            <Flex>
              <p>
                <b>€</b>
              </p>
              <h1>{price}</h1>
            </Flex>
          </Flex>
        </div>
      </div>
    );
  });

  // INTERESTS CARD
  const choosenInterests = interestsObj?.map((interest, i) => {
    const bigL = interest.interestLabel?.split("")[0].toUpperCase();
    const bigLWord = bigL.concat(interest.interestLabel?.slice(1));
    const limitedProductsToDisplay = interest.interestProducts?.slice(0, 5);
    return (
      <div key={i}>
        <Flex m="0 1rem 1rem 1rem" gap={5} align="baseline">
          <h2
          // style={{
          //   marginLeft: "1rem",
          // }}
          >
            {bigLWord}
          </h2>
          <hr
            style={{
              width: "100%",
            }}
          />
        </Flex>
        <Flex
          justify="center"
          mb="1rem"
          // style={{
          //   overflowX: "scroll",
          // }}
          gap="2rem"
        >
          {limitedProductsToDisplay?.map((prod, index) => {
            const {
              brand,
              category,
              description,
              discountPercentage,
              id,
              images,
              price,
              rating,
              stock,
              thumbnail,
              title,
            } = prod;
            const isProductInCart = realTimeData.cart?.map((item) => item.pId);

            const buttonStyle = isProductInCart?.includes(id.toString())
              ? "blue-gradient-button"
              : "blue-gradient-button-outlined";
            const linkTo = thumbnail
              ? `/products/${id}`
              : `/community-sellings/${id}`;
            return (
              <div
                style={{ cursor: "pointer" }}
                onClick={() => navigate(linkTo)}
                key={index}
                className="product-wrapper"
              >
                <div className="product-img-wrapper">
                  <img
                    className="product-img"
                    src={thumbnail ? thumbnail : images[0]}
                    alt={title}
                  />
                </div>
                <div className="second-part">
                  <Flex align="center" justify="space-between">
                    <h4>{title}</h4>
                    <button
                      style={{
                        border: "none",
                        background: "none",
                      }}
                      type="button"
                    >
                      <FavoriteOutlinedIcon
                        style={{
                          color: realTimeData.favorites?.includes(id.toString())
                            ? "rgb(255, 201, 26)"
                            : "rgb(208, 208, 208)",
                          cursor: "pointer",
                        }}
                        onClick={(e) =>
                          addOrRemoveFavorites(
                            e,
                            id,
                            userId,
                            realTimeData.favorites
                          )
                        }
                      />
                    </button>
                  </Flex>
                  <Flex align="center" gap="1rem">
                    <Rating readOnly defaultValue={rating} fractions={2} />
                    <p>{rating}/5</p>
                  </Flex>
                </div>
                <div className="third-part">
                  <Flex align="center" justify="space-between">
                    <button
                      style={{
                        padding: 5,
                      }}
                      pid={prod.id}
                      pname={prod.title}
                      pprod={price}
                      ptaxes={((19 / 100) * price).toFixed(2)}
                      onClick={(e) => pushProductToCloud(e, quantity, userId)}
                      className={buttonStyle}
                    >
                      Add to cart
                    </button>
                    <Flex>
                      <p>
                        <b>€</b>
                      </p>
                      <h1>{price}</h1>
                    </Flex>
                  </Flex>
                </div>
              </div>
            );
          })}
        </Flex>
      </div>
    );
  });

  // ALL STORE PRODUCTS CARDS
  const storeProducts = productsArr.products
    ?.slice(0, 50)
    .map((prod, index) => {
      const {
        brand,
        category,
        description,
        discountPercentage,
        id,
        images,
        price,
        rating,
        stock,
        thumbnail,
        title,
      } = prod;
      const isProductInCart = realTimeData.cart?.map((item) => item.pId);
      const buttonStyle = isProductInCart?.includes(id.toString())
        ? "blue-gradient-button"
        : "blue-gradient-button-outlined";
      const linkTo = thumbnail
        ? `/products/${id}`
        : `/community-sellings/${id}`;
      return (
        <div
          style={{ cursor: "pointer" }}
          onClick={() => navigate(linkTo)}
          key={index}
          className="product-wrapper"
        >
          <div className="product-img-wrapper">
            <img
              id="card-image"
              className="product-img"
              src={thumbnail ? thumbnail : images[0]}
              alt={title}
            />
          </div>
          <div className="second-part">
            <Flex align="center" justify="space-between">
              <h4>{title}</h4>
              <button
                style={{
                  border: "none",
                  background: "none",
                }}
                type="button"
              >
                <FavoriteOutlinedIcon
                  style={{
                    color: realTimeData.favorites?.includes(id.toString())
                      ? "rgb(255, 201, 26)"
                      : "rgb(208, 208, 208)",
                    cursor: "pointer",
                  }}
                  onClick={(e) =>
                    addOrRemoveFavorites(e, id, userId, realTimeData.favorites)
                  }
                />
              </button>
            </Flex>
            <Flex align="center" gap="1rem">
              <Rating readOnly defaultValue={rating} fractions={2} />
              <p>{rating}/5</p>
            </Flex>
          </div>
          <div className="third-part">
            <Flex align="center" justify="space-between">
              <button
                style={{
                  padding: 5,
                }}
                pid={prod.id}
                pname={prod.title}
                pprod={price}
                ptaxes={((19 / 100) * price).toFixed(2)}
                onClick={(e) => pushProductToCloud(e, quantity, userId)}
                className={buttonStyle}
              >
                Add to cart
              </button>
              <Flex>
                <p>
                  <b>€</b>
                </p>
                <h1>{price}</h1>
              </Flex>
            </Flex>
          </div>
        </div>
      );
    });

  return {
    mappedCart,
    mappedSoldByMe,
    mappedFavorites,
    mappedComFavorites,
    comProducts,
    choosenInterests,
    storeProducts,
  };
};

export default useGetMappedData;
